var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-row" }, [
      _c(
        "div",
        { staticClass: "form-group col-md-6" },
        [
          _c("br"),
          _c("label", [_vm._v("เพิ่มวงเงินค้ำประกันจำนวนเงิน(บาท)")]),
          _c("vue-numeric", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true, min_value: 1 },
                expression: "{required:true,min_value:1}"
              }
            ],
            staticClass: "form-control",
            class: { input: true, "is-danger": _vm.errors.has("lgAmt") },
            attrs: {
              separator: ",",
              precision: 2,
              name: "addLgAmt",
              placeholder: "กรุณากรอกจำนวน"
            },
            on: {
              blur: function($event) {
                return _vm.calSumLgAmt($event.target.value)
              }
            },
            model: {
              value: _vm.addLgAmt,
              callback: function($$v) {
                _vm.addLgAmt = $$v
              },
              expression: "addLgAmt"
            }
          }),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("addLgAmt"),
                  expression: "errors.has('addLgAmt')"
                }
              ],
              staticClass: "help is-danger"
            },
            [_vm._v("จำนวนเงินค้ำประกัน ไม่ถูกต้อง")]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form-group col-md-6" },
        [
          _c("br"),
          _c("label", [_vm._v("รวมเป็นวงเงินค้ำประกัน(บาท)")]),
          _c("vue-numeric", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true, min_value: 1 },
                expression: "{required:true,min_value:1}"
              }
            ],
            staticClass: "form-control",
            attrs: {
              separator: ",",
              precision: 2,
              name: "sumLgAmt",
              disabled: ""
            },
            model: {
              value: _vm.sumLgAmt,
              callback: function($$v) {
                _vm.sumLgAmt = $$v
              },
              expression: "sumLgAmt"
            }
          })
        ],
        1
      )
    ]),
    this.reqType !== 4
      ? _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "form-row" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "form-group no-label col-md-3" },
              [
                _c("date-picker", {
                  attrs: {
                    name: "addPeriodStartDate",
                    lang: "th",
                    format: "DD/MM/YYYY",
                    "data-vv-as": "ตั้งแต่วันที่",
                    placeholder: "",
                    disabled: ""
                  },
                  model: {
                    value: _vm.addPeriodStartDate,
                    callback: function($$v) {
                      _vm.addPeriodStartDate = $$v
                    },
                    expression: "addPeriodStartDate"
                  }
                })
              ],
              1
            ),
            _vm._m(1),
            _c(
              "div",
              { staticClass: "form-group no-label col-md-3" },
              [
                _c("date-picker", {
                  attrs: {
                    name: "addPeriodEndDate",
                    lang: "th",
                    format: "DD/MM/YYYY",
                    placeholder: "",
                    disabled: ""
                  },
                  model: {
                    value: _vm.addPeriodEndDate,
                    callback: function($$v) {
                      _vm.addPeriodEndDate = $$v
                    },
                    expression: "addPeriodEndDate"
                  }
                })
              ],
              1
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group no-label col-md-2" }, [
      _c("label", [_vm._v("ตั้งแต่วันที่")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group no-label col-md-2" }, [
      _c("label", [_vm._v("ถึงวันที่")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }